export const shouldDisplayRelatedOutcode = (path: string) => {
    const pathParts = path.split('/');
    const ukPostcodeRegex = /^[A-Za-z]{1,2}\d[A-Za-z\d]?-\d[A-Za-z]{2}$/i;

    return pathParts.some(
        (part) =>
            ['schools', 'station'].includes(part) || ukPostcodeRegex.test(part)
    );
};
